export default __webpack_public_path__ + "static/media/crop_pattern_summer_winter.1cd00024.jpg";